// src/routes/Viewer.jsx
import React from "react";
import TattooApp from "../tattoo/TattooApp.jsx";
import { tattoo } from "../tattoo/state";

export default function Viewer() {
  React.useEffect(() => {
    tattoo.readOnly = true;
    return () => {
      tattoo.readOnly = false;
    };
  }, []);

  return <TattooApp readOnly />;
}